import { Check, CheckCircle2, Send, ShieldCheck, Sparkles } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";

export function LessonCustomForm({ form, courseId, lessonId }) {
  const [values, setValues] = useState({});
  const [sent, setSent] = useState(false);
  const [sending, setSending] = useState(false);
  if (!form?.enabled) return null;
  const fields = form.fields || [];
  const completed = fields.filter((field) => {
    const value = values[field.id];
    return field.type === "checkbox" ? Boolean(value) : Boolean(String(value || "").trim());
  }).length;
  const progress = fields.length ? Math.round(completed / fields.length * 100) : 100;
  const setValue = (id, value) => setValues((current) => ({ ...current, [id]: value }));
  const submit = async () => {
    setSending(true);
    try {
      await api.post(`/courses/${courseId}/lessons/${lessonId}/form`, { values });
      setSent(true);
      toast.success("Formularz został wysłany");
    } catch (error) { toast.error(error.response?.data?.detail || "Uzupełnij formularz"); }
    finally { setSending(false); }
  };

  return <section className="lesson-custom-form" data-testid="lesson-custom-form">
    <div className="custom-form-glow" aria-hidden="true"/>
    <header>
      <div className="custom-form-kicker"><Sparkles/><span>TWÓJ KOLEJNY KROK</span></div>
      <h2>{form.title || "Formularz"}</h2>
      {form.description ? <p>{form.description}</p> : null}
      {!sent ? <div className="custom-form-progress"><span><b>{completed}</b> z {fields.length} pól</span><strong>{progress}%</strong><i><b style={{ width: `${progress}%` }}/></i></div> : null}
    </header>
    {sent ? <div className="custom-form-success"><Check/><div><strong>Dziękujemy — odpowiedź została zapisana.</strong><small>Możesz kontynuować naukę. Wrócimy z odpowiedzią, jeśli będzie potrzebna.</small></div></div> : <div className="lesson-form-fields">
      {fields.map((field, index) => <div className={`lesson-form-field ${field.type === "checkbox" ? "checkbox-field" : ""}`} key={field.id}>
        {field.type !== "checkbox" ? <span><b>{String(index + 1).padStart(2, "0")}</b>{field.label}{field.required ? <em>WYMAGANE</em> : null}</span> : null}
        {field.type === "textarea" ? <textarea value={values[field.id] || ""} onChange={(event) => setValue(field.id, event.target.value)} placeholder={field.placeholder || "Napisz odpowiedź…"}/>
          : field.type === "select" ? <div className="form-radio-options" role="radiogroup" aria-label={field.label}>{(field.options || []).map((option) => <label className={values[field.id] === option ? "selected" : ""} key={option}><input type="radio" name={`lesson-field-${field.id}`} value={option} checked={values[field.id] === option} onChange={(event) => setValue(field.id, event.target.value)}/><i/><span>{option}</span></label>)}</div>
          : field.type === "checkbox" ? <label className="form-checkbox-option"><input type="checkbox" checked={Boolean(values[field.id])} onChange={(event) => setValue(field.id, event.target.checked)}/><span><CheckCircle2/>{field.label}{field.required ? " *" : ""}</span></label>
          : <input type={field.type === "email" ? "email" : field.type === "phone" ? "tel" : "text"} value={values[field.id] || ""} onChange={(event) => setValue(field.id, event.target.value)} placeholder={field.placeholder || "Wpisz odpowiedź…"}/>}</div>)}
      <button className="custom-form-submit" onClick={submit} disabled={sending}><span><Send/> {sending ? "WYSYŁANIE…" : form.submit_label || "WYŚLIJ"}</span><small>Zapisz odpowiedzi bez opuszczania lekcji</small></button>
      <div className="custom-form-trust"><ShieldCheck/><span>Twoje dane trafiają bezpośrednio do zespołu MARSEM.</span></div>
    </div>}
  </section>;
}
